const ConfirmModal = ({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="dashboard-modal-backdrop" onClick={onCancel} role="presentation">
      <div className="dashboard-modal" onClick={(e) => e.stopPropagation()} role="dialog">
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="dashboard-modal__actions">
          <button type="button" className="dashboard-btn dashboard-btn--secondary" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`dashboard-btn ${danger ? "dashboard-btn--danger" : "dashboard-btn--primary"}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Please wait…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
